import React from "react";
import { GiRibbonMedal } from "react-icons/gi";
function GridOverlay2() {
  return (
    <div className="relative h-56 w-72  flex items-center justify-center bg-gray-100">
      {/* Grid Container */}
      <div className="grid grid-cols-2 h-56 w-72 ">
        {/* Grid Items */}
        <div className="bg-white h-full w-full"></div>
        <div className="bg-white h-full w-full"></div>
        <div className="bg-white md:bg-customAqua600 lg:bg-customAqua600  h-full w-full"></div>
        <div className="bg-white h-full w-full"></div>
      </div>

      {/* Overlay Div */}
      <div className="absolute p-4 z-10 w-full h-full rounded-[40px] bg-customAqua600  flex flex-col justify-around text-white font-semibold">
        <GiRibbonMedal  className="w-12 h-12 text-customAqua100 "  />
        <p className="text-lg font-semibold">Dentiste professionnel</p>
        <p className="font-normal text-sm">
        L'équipe comprend des dentistes, des assistants dentaires et du personnel administratif qui travaillent ensemble.
        </p>
      </div>
    </div>
  );
}

export default GridOverlay2;
